// extracted by mini-css-extract-plugin
export default {"container":"PL-z","modal":"QL-z","dimensions":"RL-z","brandName":"SL-z","productName":"TL-z","labelValue":"UL-z","recipientEmail":"VL-z","recommendedFit":"WL-z","hiddenField":"XL-z"};